import axios from "axios";
import { transformObjectToSnakeCase, transformObjectToCamelCase } from "../utils/caseTransform.js";

const auditBackClient = axios.create({
  baseURL: import.meta.env.VITE_APP_BACK_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Transform request data from camelCase to snake_case
auditBackClient.interceptors.request.use(
  (config) => {
    if (config.data) {
      config.data = transformObjectToSnakeCase(config.data);
    }
    if (config.params) {
      config.params = transformObjectToSnakeCase(config.params);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Transform response data from snake_case to camelCase
auditBackClient.interceptors.response.use(
  (response) => {
    if (response.data) {
      response.data = transformObjectToCamelCase(response.data);
    }
    return response;
  },
  (error) => {
    if (error.response?.data) {
      error.response.data = transformObjectToCamelCase(error.response.data);
    }
    return Promise.reject(error);
  },
);

const initAuditPPPRestAuth = (accessToken) => {
  auditBackClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
};

export default auditBackClient;
export { auditBackClient, initAuditPPPRestAuth };
